<template>
  <div>
    <b-row>
      <b-col>
        <h3>Template</h3>
        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
          <b-button-group class="mx-1">
            <b-button>&laquo;</b-button>
            <b-button>&lsaquo;</b-button>
          </b-button-group>
          <b-button-group class="mx-1">
            <b-button>Edit</b-button>
            <b-button>Undo</b-button>
            <b-button>Redo</b-button>
          </b-button-group>
          <b-button-group class="mx-1">
            <b-button>&rsaquo;</b-button>
            <b-button>&raquo;</b-button>
          </b-button-group>
        </b-button-toolbar>
      </b-col>
      <b-col>
        <h3>Preview</h3>
        <b-button-group>
          <b-button variant="warning">Mobile </b-button>
          <b-button>Tablet/Desktop</b-button>
          <b-button>SMS</b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col>
        <b-form-group>
          <label-info
            id="subject-line"
            label-name="Subject Line"
            label-info=""
            :is-required="true"
          />
          <b-form-input
            type="text"
            required
            v-model="currentEmailSubject"
            placeholder="Subject Line"
          />
        </b-form-group>
        <b-form-textarea v-model="currentEmailBody" />
      </b-col>
      <b-col
        style="background-color: #9a9898; border-radius: 10px;height: 500px"
      >
        <tip-tap-output
          v-if="false"
          style="
      overflow-y: scroll;
      height:70vh;
      margin-top: 25px;
      margin-left: 25px;
      border-radius: 15px;
      background-color:rgba(126,102,155,0.51);
      padding:15px;
      color: whitesmoke;
      "
          :content="sessionEmailTemplate"
          :use-dots="true"
        />
        <div v-else>
          No Preview Available
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TipTapOutput from "@/components/common/tipTapOutput";
import LabelInfo from "@/components/common/labelInfo";
export default {
  name: "Sessions_Emails",
  components: {
    TipTapOutput,
    LabelInfo
  },
  props: {
    session: {
      type: Object,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    notificationJson: {
      type: Object,
      default: () => {
        return {};
      }
    },
    emailType: {
      type: String,
      default: "invitation"
    }
  },
  mounted() {},
  computed: {
    emailTpls() {
      return this.notificationJson &&
        this.emailType &&
        this.notificationJson.notifications &&
        this.notificationJson.notifications[this.emailType] &&
        Array.isArray(this.notificationJson.notifications[this.emailType])
        ? this.notificationJson.notifications[this.emailType]
        : [];
    },
    currentTpl() {
      return this.emailTpls.length > this.idx && this.emailTpls[this.idx]
        ? this.emailTpls[this.idx]
        : null;
    },
    currentEmail() {
      return this.currentTpl && this.currentTpl.email
        ? this.currentTpl.email
        : null;
    },
    currentEmailSubject() {
      return this.currentEmail && this.currentEmail.subject
        ? this.currentEmail.subject
        : "";
    },
    currentEmailBody() {
      return this.currentEmail && this.currentEmail.tpl
        ? this.currentEmail.tpl
        : "";
    }
  },
  methods: {
    handleAddDataButtonClick() {
      this.$emit("add-data-click");
    }
  },
  data() {
    return {
      formEmail: {
        subject: null,
        tpl: null
      },
      idx: 0
    };
  }
};
</script>

<style lang="scss" scoped></style>
